import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=0b45ea80&"
import script from "./page-header.vue?vue&type=script&lang=js&"
export * from "./page-header.vue?vue&type=script&lang=js&"
import style0 from "./page-header.vue?vue&type=style&index=0&id=0b45ea80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports